module.exports = __webpack_public_path__ + "img/renewables.6314715.jpg";